<template>
  <el-container
    id="Ngaodu"
    :class="tolist1 == 2? 'Ngaodu':''"
    :style="addFooter3?'height: 100%;':''"
  >
    <el-header
      class="nav-header-bg nav-pd0"
      id="tob_te"
      :style="$route.name=='Home1111' || '' ?'':'background-color: #fff;box-shadow: darkgrey -5px -2px 4px 2px;'"
    >
      <el-row
        class="NavTabs_box"
        id="tob_to2"
        :style="$route.name=='Home1111' || '' ?'display: none;':''"
      >
        <el-col :span="7" class="logo">
          <router-link :to="{name:'Home'}">
            <div class="nav-pd nav-image">
              <img src="../assets/img/logo-eimskip2.png" />
            </div>
          </router-link>
        </el-col>
        <el-col :span="12" class="middle">
          <el-menu
            router
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#fff"
            text-color="#1b1464"
            active-text-color="#1b1464"
            style="border-bottom: solid 0px #1b1464;"
          >
            <el-menu-item index="/home" class="tab-font web-font">首页</el-menu-item>
            <el-menu-item index="/shipSchedule" class="tab-font">船期查询</el-menu-item>
            <el-menu-item index="/ShippingPlan" class="tab-font">船舶计划</el-menu-item>
            <el-menu-item index="/ogisticsTrack" class="tab-font">物流跟踪</el-menu-item>
            <el-menu-item index="/aboutUs" class="tab-font">关于我们</el-menu-item>
            <el-menu-item
              index="/logisticsManage/account"
              class="tab-font"
              :style="addFooter2?'border-bottom: 2px solid rgb(27, 20, 100) ;font-weight: 700;':''"
            >物流管家</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="7" class="quit">
          <div class="nav-pd" style="float:right;">
            <el-row v-show="logState">
              <el-button
                size="mini"
                style="font-family:'SourceHanSans-Regular';background-color:rgba(255,255,255,0); border: 1px solid #1B1464; color: #1B1464;border-radius: 0px;"
                type="primary"
                class="rginteraction"
                @click="login"
              >登录</el-button>
              <el-button
                size="mini"
                class="rginteraction"
                style="font-family:'SourceHanSans-Regular';background-color:rgba(255,255,255,0); border: 1px solid #1B1464; color: #1B1464;border-radius: 0px;"
                type="primary"
                @click="register"
              >注册</el-button>
            </el-row>
            <el-row v-show="!logState">
              <el-button
                size="mini"
                type="text"
                style="color: #1B1464; font-family:'SourceHanSans-Regular'; font-size:14px;"
                @click="logistics"
              >{{userName}}</el-button>
              <el-button
                size="mini"
                class="rginteraction"
                style="font-family:'SourceHanSans-Regular';background-color:rgba(255,255,255,0); border: 1px solid #1B1464; color: #1B1464;border-radius: 0px;"
                type="primary"
                @click="logout"
              >退出</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="nav-pd0 nav-main-mr">
      <!-- :class="$route.name=='LogisticsManage' || '' ?'':'nav-main-mr'" -->
      <div class="top_tu headerMain-bg" id="top_sole"></div>

      <router-view></router-view>
    </el-main>
    <el-footer
      class="nav-pd0"
      :class="[{'new-nav-footer':addFooter}]"
      style="background-color: #ffff;height: 80px;"
    >
      <div class="nav-footer">
        <div class="nav-font-footer" align="center">
          © Copyright 2012-2020 中航运捷运物流（上海）有限公司
          <a
            class="nav-font-footer"
            href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            target="_blank"
          >沪ICP备2020029382号-1</a>版权所有
        </div>
        <div style="padding-top:5px;">
          <a
            class="nav-font-footer"
            :underline="false"
            href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            target="_blank"
          >
            <img class="party" src="../assets/img/party2.gif" alt />
            <img class="party" src="../assets/img/party.png" alt />
            沪公网安备 31011502016842号
          </a>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
// import ElButton from "../../node_modules/element-ui/packages/button/src/button";
// import ElLink from "../../node_modules/element-ui/packages/link/src/main";
export default {
  // components: { ElLink, ElButton },
  data() {
    return {
      tolist1: "",
      userName: "", //用户信息
      logState: ""
    };
  },
  mounted() {
    var getUser = localStorage.getItem("userInfo");
    if (getUser) {
      this.userName = JSON.parse(getUser).userNameCn;
    } else {
      this.userName = "";
    }
    this.logState = this.loginState();
    const topSole = document.getElementById("top_sole"),
      header = document.getElementById("tob_te"),
      headerMain2 = document.getElementById("tob_to2"),
      button = document.getElementById("top_sole");
    window.onscroll = computedDisplay;
    function computedDisplay() {
      var curTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (curTop > 10) {
        topSole.classList.add("headerMain-bg2");
        header.classList.add("na_tab");
        headerMain2.classList.add("headerMain-bg2");
      } else {
        topSole.classList.remove("headerMain-bg2");
        header.classList.remove("na_tab");
        headerMain2.classList.remove("headerMain-bg2");
      }
    }
    button.onclick = function() {
      let curTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      curTop = 0;
      document.documentElement.scrollTop = curTop;
      topSole.classList.remove("headerMain-bg2");
      header.classList.remove("na_tab");
      // headerMain.classList.remove("headerMain-bg");
      headerMain2.classList.remove("headerMain-bg2");
    };
  },
  computed: {
    addFooter: {
      //用于控制底部样式new-nav-footer加载
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "ShipSchedule":
              return true;
              break;
            case "LogisticsManage":
              return true;
              break;
            case "Account":
              return true;
              break;
            case "Order":
              return true;
              break;
            case "OgisticsTrack":
              return true;
              break;
            case "OrderTwo":
              return true;
              break;
            case "Bill":
              return true;
              break;
            case "ShippingPlan":
              return true;
              break;

            default:
              return false;
              break;
          }
        }
      }
    },
    addFooter2: {
      //用于控制底部样式new-nav-footer加载
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "LogisticsManage":
              return true;
              break;
            case "Account":
              return true;
              break;
            case "Order":
              return true;
              break;
            case "OrderTwo":
              return true;
              break;
            case "Bill":
              return true;
              break;
            default:
              return false;
              break;
          }
        }
      }
    },
    addFooter3: {
      //用于控制底部样式new-nav-footer加载
      get: function() {
        if (this.$route.name) {
          switch (this.$route.name) {
            case "LogisticsManage":
              return true;
              break;
            case "Account":
              return true;
              break;

            default:
              return false;
              break;
          }
        }
      }
    }
  },
  methods: {
    //登录状态
    loginState: function() {
      if (this.$cookies.get("username") && this.$cookies.get("password")) {
        return false;
      } else {
        return true;
      }
    },
    handleSelect: function(key, keyPath) {
      //tab变化
      // console.log(key, keyPath);
    },
    //登录
    login() {
      this.$router.push({ name: "Login" });
    },
    //注册
    register() {
      this.$router.push({ name: "Register" });
    },
    //退出
    logout() {
      this.$cookies.remove("username");
      this.$cookies.remove("password");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("queryData");
      this.logState = this.loginState();
      this.$router.go(0);
    },
    logistics() {
      if (this.$router.history.current.name !== "Account") {
        this.$router.push({
          name: "Account"
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.na_tab {
  background-color: #fff;
  border-bottom: 1px solid f1f1f1;
  box-shadow: darkgrey -5px -2px 4px 2px;
}
/* 盒子 */
.NavTabs_box {
  width: 1200px !important;
  margin: 0 auto !important;
}
/* 左边 */
.logo {
  float: left !important;
  width: 10px !important;
}
/* 中间 */
.middle {
  margin-left: 400px !important;
}
/* 右边 */
.quit {
  float: right !important;
  width: 150px !important;
}

.nav-pd0 {
  height: 100%;
}
.Ngaodu {
  height: 100%;
}
</style>













// WEBPACK FOOTER //
// src/views/NavTabs.vue